module.exports = __webpack_public_path__ + "static/media/InfoIcon.39557ec5.svg";